import portal from './portal.vue'
export default portal
